module.exports = __webpack_public_path__ + "img/bar-chart-view.70862bce.svg";